/* eslint-disable vue/no-reserved-keys */
<template>
  <v-container>
    <v-toolbar
      color="fercamGridColor"
      class="elevation-1"
    >
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="fullTextSearch"
        :placeholder="$t('grid.Search')"
        solo
        append-icon="fas fa-search"
        class="gridSearch"
        v-on:keyup.enter="performSearch"
      >
      </v-text-field>
      <v-menu
        offset-y
        v-if="ShowMenu && (CanCreate || CanDownload)"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="gridButton"
          >
            <v-icon>fas fa-cogs</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-if="CanCreate"
            @click="create"
          >
            <v-list-item-title class="contextMenu">{{ CreateLabel }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="CanDownload"
            @click="download('jpg')"
          >
            <v-list-item-title class="contextMenu">{{ $t('ContextMenu.Download') }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="CanDownload"
            @click="download('pdf')"
          >
            <v-list-item-title class="contextMenu">{{ $t('ContextMenu.DownloadPdf') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-row
      class="color-filter-bar ma-0"
      v-if="showColumnFilters"
    >
      <v-btn
        text
        color="white"
        class="ma-1"
        @click="dialogFilter=true"
      >
        <v-icon>fas fa-filter</v-icon>Filters
      </v-btn>
      <v-chip
        v-for="(filter, index) in filters"
        :key="index"
        close
        label
        class="ma-2 style-chip"
        @input="remove(filter.item)"
      >{{filter.field}} {{filter.filterType}} {{filter.filtervalue}}</v-chip>
    </v-row>
    <v-data-table
      :headers="calculatedHeaders"
      :exportHeaders="eHeaders"
      :items="items"
      :options.sync="pagination"
      :server-items-length="totalRows"
      :loading="loading"
      :must-sort="false"
      :rowsPerPageItems="[10,20,50,100]"
      :sort-by="getSortBy()"
      sort-desc
      class="elevation-3"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="fileName"
      show-expand
      :footer-props="{
        'itemsPerPageOptions': [10, 50, 100, -1]
      }"
    >
      <template v-slot:actions-append>
        <v-btn
          text
          icon
          color="fercamColor"
          @click="reload"
        >
          <v-icon size="15">fas fa-sync</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-alert
          :value="true"
          color="error"
          icon="warning"
        >Nothing to display here.</v-alert>
      </template>
      <template v-slot:item="{item}">
        <tr>
          <td></td>
          <td
            class="d-block d-sm-table-cell"
            v-on:dblclick="preview(item)"
            @contextmenu.prevent="$refs.menu.open($event,{name:item})"
            v-for="(calculatedHeaders, i) in calculatedHeaders"
            :key="i"
          >          
          <span v-if="calculatedHeaders.value == 'status'">
            {{  item[calculatedHeaders.value] == true ? $t("grid.ActiveColumn") : $t("grid.DisactiveColumn") }}
          </span>
          <span v-else>
            {{  item[calculatedHeaders.value] }}
          </span>
          </td>
        </tr>
      </template>
      <!-- <template v-slot:expanded-item="{ headers }">

        <td
          v-if="canExpand"
          :colspan="headers.length"
          style="padding: 0px"
        >
          <v-data-table
            :headers="headers"
            :items="childItems"
            :disable-sort="true"
            :hide-default-footer="true"
            :loading="childGridLoading"
            :loading-text="$t('grid.LoadingText')"
            :no-data-text="$t('grid.NoData')"
            class="elevation-3 nestedGrid"
            :footer-props="{
        'itemsPerPageOptions': [10, 50, 100, -1]
        }"
          ></v-data-table>
        </td>
      </template> -->

      <!-- :class="isHiddenColumn(key1)" -->

      <!-- <template v-if="EnableCounters" v-slot:footer>
        <tr>
          <td
            v-for="(value,key) in items[0]"
            v-bind:key="key"
            :class="isHiddenColumn(key)+' text-start'"
            v-html="'<b>'+counters[key]?counters[key]:''+'</b>'"
          ></td>
        </tr>
      </template>-->
    </v-data-table>

    <vue-context ref="menu">
      <ul slot-scope="child">
        <li
          @click="Edit(child)"
          v-if="!disableEdit"
        >
          <i class="fas fa-pencil-alt"></i>
          <span>&nbsp; Edit</span>
        </li>
        <li
          @click="Delete(child.data.name.Id)"
          v-if="!disableDelete"
        >
          <i class="fas fa-trash"></i>
          <span>&nbsp; Delete</span>
        </li>
        <slot v-bind:child="child"></slot>
      </ul>
    </vue-context>
    <v-snackbar
      v-model="snackbar.Visible"
      :color="snackbar.Color"
      :timeout="snackbar.Timeout"
    >
      {{ snackbar.Message }}
      <v-btn
        dark
        text
        @click="snackbar.Visible = false"
      >Close</v-btn>
    </v-snackbar>

    <v-dialog
      v-model="dialogDelete"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">Eliminare l'oggetto selezionato?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            dark
            color="green darken-1"
            @click="dialogDelete = false;"
          >NO</v-btn>
          <v-btn
            dark
            color="red darken-1"
            @click="dialogDelete = false;DeleteConfirmed()"
          >SI</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogFilter"
      max-width="500"
    >
      <v-card>
        <v-card-title primary-title>
          <h3 class="headline mb-0">Add Filter</h3>
        </v-card-title>
        <v-form>
          <v-container>
            <v-row
              wrap
              class="pa-2"
            >
              <v-flex md12>
                <v-select
                  :items="headersFilter"
                  color="lightgrey"
                  v-model="column"
                  label="Column"
                  :error-messages="columnErrors"
                  @input="filterFieldSelected"
                  @blur="$v.column.$touch()"
                ></v-select>
              </v-flex>
              <v-flex md12>
                <v-select
                  v-if="!isBoolean"
                  :items="currentTypeFiltersList"
                  color="lightgrey"
                  v-model="filter"
                  label="Filter"
                  :error-messages="filterErrors"
                  @input="$v.filter.$touch()"
                  @blur="$v.filter.$touch()"
                ></v-select>
              </v-flex>
              <v-flex md12>
                <v-text-field
                  v-if="!isBoolean"
                  name="name"
                  color="lightgrey"
                  label="Value"
                  v-model="value"
                  :type="currentTypeFilters"
                  :error-messages="valueErrors"
                  @input="$v.value.$touch()"
                  @blur="$v.value.$touch()"
                ></v-text-field>
                <v-switch
                  v-if="isBoolean"
                  v-model="valueBoolean"
                  :label="`${currentFilter}`"
                ></v-switch>
              </v-flex>
            </v-row>
          </v-container>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="button-add-filters"
            @click="addFilter"
          >Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { VueContext } from "vue-context";
import { required } from "vuelidate/lib/validators";
import router from "@/router/index.js";
import HyperstorageApi from "../api/Hyperstorage/api.js";
import PODApi from "../api/PODPortal/api.js";
import moment from 'moment-timezone';

const requiredMsg = "Campo obbligatorio.";
export default {
  components: { VueContext },

  validations: {
    column: { required },
    value: { required },
    filter: { required }
  },

  props: {
    // titolo in alto a sinistra nell'header della griglia
    title: String,
    // testo del bottone di aggiunta elemento
    newLabel: String,
    // visualizzazione del bottone crea elemento
    CanCreate: Boolean,
    // nome del controller della webapi per fare le chiamate crud base
    CreateLabel: String,
    ShowMenu: Boolean,
    CanDownload: Boolean,
    DownloadLabel: String,
    controller: String,
    //nome del controller che uso per l'edit con il doppio click
    controllerEdit: String,
    createComponentRoute: String,
    delete: String,
    edit: String,
    readAll: String,
    // lista delle colonne della griglia con i relativi settaggi {text:'Storage' value: 'Storage', sortable: false, width: '5', filterable: false, type: Boolean }
    // sono richiesti: value (nome colonna sul db) e type (solo se il tipo di dato è diverso da stringa)

    // filtri per colonne che non sono visualizzate nel front end ma che sulla tabella del db esistono
    customFilters: Array,
    // disabilito pulsante Edit menu contestuale
    disableEdit: Boolean,
    // disabilito pulsante Delete menu contestuale
    disableDelete: Boolean,
    // nomi colonne da nascondere
    hideColumns: Array,
    // refresh griglia
    refresh: Boolean,
    //Enable Counters
    EnableCounters: Boolean,
    CounterColumns: Array,
    //headers opzionali, se vuoto li crea partendo dall'oggetto
    Headers: Array,
    //filtri che passo alla grid
    externalFilters: Array,
    //filtri che passo al controllo ricerca
    searchFields: String,
    //decido se colorare o no le celle
    colorRow: Boolean,
    //dati che passo quando faccio la modifica
    childData: String,
    showFooter: { type: Boolean, default: true },
    exportHeaders: Array,
    showColumnFilters: { type: Boolean, default: false },
    canExpand: { type: Boolean, default: true },
    //Grid type: PODSearch, ClientConfiguration
    gridType: String
  },

  data() {
    return {
      expanded: [],
      singleExpand: true,
      calculatedHeaders: [],
      eHeaders: [],
      snackbar: { Timeout: 10000, Visible: false },
      dialogDelete: false,
      dialogFilter: false,
      CurObj: "",
      items: [],
      totalRows: 0,
      filters: [],
      counters: {},
      column: "",
      filter: "",
      value: "",
      valueBoolean: false,
      isBoolean: false,
      currentFilter: "",
      pagination: {},
      headersFilter: [],
      currentTypeFilters: "",
      currentTypeFiltersList: [],
      childItems: [],
      childGridLoading: false,
      fullTextSearch: "",
      loading: false,
    };
  },

  destroyed() {
    this.$emit("destroyed");
  },
  beforeCreate() {
    this.$emit("beforeMount");
  },
  created() {
    this.$emit("created");
  },
  beforeMount: function() {
    this.$emit("beforeMount");
    this.CalculateHeadersFilter();
  },
  mounted() {
    this.$emit("mounted");
  },
  watch: {
    pagination: {
      handler() {
        this.reload();
      },
      deep: true
    },
    // filters: {
    //   handler() {
    //     this.reload();
    //   },
    //   deep: true
    // },
    refresh: {
      handler() {
        this.reload();
      }
    }
  },

  methods: {

    getSortBy(){
      var str = "";

      switch(this.gridType){
        case "PODSearch":
          str = "shipmentDate";
          break;

        case "ClientConfiguration":
          str = "lastProcessingDate";
          break;
      }

      return str;
    },

    preview(item) {
      if(this.gridType == "PODSearch"){
       this.$emit("podPreview", item); 
      }
      //console.log("preview", item, this.gridType);
    },

    performSearch() {
      var item = this.filters.find(
        filter => filter.FilterType == "FullTextWithLike"
      );
      if (item) {
        this.filters.splice(this.filters.indexOf(item), 1);
        this.filters = [...this.filters];
      }
      var newFilter = {
        Field: this.searchFields,
        Filtervalue: this.fullTextSearch,
        FilterType: "FullTextWithLike"
      };

      localStorage.setItem(
        "FullTextWithLike",
        JSON.stringify(newFilter)
      );

      this.reload();
    },

    // clicked(value) {
    //   if (!this.canExpand) return;
    //   if (this.expanded.filter(x => x.id == value.id).length == 1) {
    //     this.expanded = [];
    //     return;
    //   }

    //   this.childItems = [];
    //   this.expanded = [];
    //   this.expanded.push(value);
    //   this.childGridLoading = true;

    //   // let data = {
    //   //   SortBy: [],
    //   //   CounterColumns: [],
    //   //   Descending: false,
    //   //   Page: 1,
    //   //   RowsPerPage: 10000,
    //   //   Filters: [
    //   //     {
    //   //       Field: "FileName",
    //   //       Filtervalue: "`_",
    //   //       FilterType: "Contains"
    //   //     },
    //   //     {
    //   //       Field: "ShipmentCode",
    //   //       Filtervalue: value.shipmentCode,
    //   //       FilterType: "Contains"
    //   //     }
    //   //   ]
    //   // };
    //   HyperstorageApi.GetAdditionalDocument(value.shipmentCode)
    //     .then(res => {
    //       this.childItems = res.data;
    //       this.childGridLoading = false;
    //     })
    //     .catch(e => {
    //       //this.showErr=true;
    //       //this.textErr=e.response.data;
    //       this.childGridLoading = false;
    //     });
    // },
    //
    // DELETE
    // mostra il popup di conferma eliminazione elemento
    Delete: function(obj) {
      this.dialogDelete = true;
      this.CurObj = null;
      this.CurObj = obj;
    },
    // dopo la conferma dell'eliminazione chiama la webapi per fare la delete vera e propria
    DeleteConfirmed: function() {
      this.$http
        .get(this.controller + this.Delete + "?Id=" + this.CurObj)
        .then(result => {
          this.snackbar.Color = "success";
          this.snackbar.Visible = true;
          this.snackbar.Message = result.data;
          this.reload();
        })
        .catch(result => {
          this.snackbar.Color = "error";
          this.snackbar.Visible = true;
          this.snackbar.Message = result.response.data;
        });
    },
    //
    // EDIT
    //
    Edit: function(obj) {
      var myId = obj.Id;
      //if (this.childData)
      //  myId=obj[this.childData];
      //if (!this.disableEdit) {
      //router.push({name: this.controllerEdit, params: { Id: myId } });
      //this.$router.push(this.controllerEdit + obj);
      //this.$router.push(this.controller + this.edit + obj);
      //}
    },

    //
    // READ
    //
    getDataFromApi() {
      var dataToPass;
      if (this.externalFilters)
        dataToPass = this.filters.concat(this.externalFilters);
      else dataToPass = this.filters;

      this.loading = true;
      let { sortBy, sortDesc, page, itemsPerPage } = this.pagination;

      let filters = {
        //TODO
        sortBy: sortBy,
        descending: sortDesc[0],
        page: page,
        rowsPerPage: itemsPerPage,
        CounterColumns: this.CounterColumns,
        filters: dataToPass
      };

      return this.$http.post(this.controller + this.readAll + "/", filters);
    },

    reload() {
        if(this.gridType == "PODSearch"){
          if(this.externalFilters){
            var clientCode = this.externalFilters.filter(x => x.Field == "ClientCode");
            var shipmentCode = this.externalFilters.filter(x => x.Field == "ShipmentCode");

            if(!clientCode && !shipmentCode){
              return;
            }
          }else{
            return;
          }       
        }

          var lolSFilter = JSON.parse(localStorage.getItem("FullTextWithLike"));

          if(lolSFilter){
            this.filters.push(lolSFilter);
           }else{
              var filterObj = this.filters.findIndex(obj => { return obj.FilterType == "FullTextWithLike"});
              if(filterObj > -1){
                this.filters.splice(filterObj, 1);
                this.fullTextSearch = "";
              }    
           }

           var dataToPass;
          if (this.externalFilters)
            dataToPass = this.filters.concat(this.externalFilters);
          else dataToPass = this.filters;

          this.loading = true;

          let { sortBy, sortDesc, page, itemsPerPage } = this.pagination;

          let filters = {
            //TODO
            sortBy: sortBy,
            descending: sortDesc[0],
            page: page,
            rowsPerPage: itemsPerPage,
            CounterColumns: this.CounterColumns,
            filters: dataToPass
          };

          //console.log("grid api", this.controller + this.readAll);
          PODApi.Get(this.controller + this.readAll, filters, "post").then(data => {
          
          this.loading = false;
          this.items = data.data.items;
          this.counters = data.data.counters;
          this.totalRows = data.data.totalRows;
          
          this.items.forEach(element => {
            if(element.creationDate) {
              element.creationDate = moment.utc(element.creationDate).tz('Europe/Rome').format('DD/MM/YYYY HH:mm:ss');
            }

            if(element.lastModified) {
              element.lastModified = moment.utc(element.lastModified).format('DD/MM/YYYY HH:mm');
            }
          });

          if (!this.Headers) {
            this.calculatedHeaders = [];
          }
          var table = document.getElementsByTagName("table");
          var row = null;
          if (this.showFooter && this.items.length > 0) {
            table[0].deleteTFoot();
            var tfoot = table[0].createTFoot();
            row = tfoot.insertRow(0);
          } else {
            table[0].deleteTFoot();
          }
          var count = 0;
          if (!this.Headers) {
            Object.getOwnPropertyNames(data.data.items[0]).forEach(element => {
              if (element !== "__ob__" && element !== "RowNum") {
                var header = {
                  value: element,
                  text: element
                };
                this.calculatedHeaders.push(header);
                if (row) {
                  var cell = row.insertCell(count);
                  count++;
                  cell.classList.add("text-start");
                  cell.innerHTML = this.counters[element]
                  ? "<b>" + this.counters[element] + "</b>"
                  : "";
                }
              }
            });
          } else {
            this.calculatedHeaders = this.Headers;
            this.Headers.forEach(header => {
              if (row) {
                var cell = row.insertCell(count);
                count++;
                cell.classList.add("text-start");
                cell.innerHTML = this.counters[header.value]
               ? "<b>" + this.counters[header.value] + "</b>"
                : "";
              }
            });
          }

          this.CalculateHeadersFilter();
          this.$emit("OnComplete");
        });
    },

    //
    // FILTERS
    //

    // Calcola i campi disponibili per essere filtrati
    CalculateHeadersFilter() {
      this.headersFilter = this.calculatedHeaders.slice();
      if (this.customFilters) {
        this.customFilters.forEach(cf => {
          this.headersFilter.push(cf);
        });
      }

      this.headersFilter.forEach(hf => {
        if (hf.filterable === false) {
          this.headersFilter.splice(this.headersFilter.indexOf(hf), 1);
        }
      });

      this.filters.forEach(filtr => {
        var index = -1;
        this.headersFilter.forEach(hf => {
          if (hf.filterable === false) {
            index = this.headersFilter.indexOf(hf);
          }
          if (hf.value === filtr.field) {
            index = this.headersFilter.indexOf(hf);
          }
        });
        this.headersFilter.splice(index, 1);
      });
    },

    /// rimuove il filtro dalla lista dei filtri disponibili per evitare di filtrare piu volte lo stesso campo

    remove(item) {
      this.filters.splice(this.filters.indexOf(item), 1);
      this.filters = [...this.filters];
      this.CalculateHeadersFilter();
    },
    addFilter: function() {
      if (!this.isBoolean) {
        this.$v.$touch();
        if (this.$v.$error) return;
      }
      var filter = {
        filterType: this.isBoolean ? "Equal" : this.filter,
        field: this.column,
        filtervalue: this.isBoolean ? this.valueBoolean : this.value
      };

      this.filters.push(filter);
      this.dialogFilter = false;
      this.filter = null;
      this.column = null;
      this.value = null;
      this.isBoolean = false;
      this.CalculateHeadersFilter();
    },
    // quando si cambia il campo da filtrare prepara il resto della form al tipo di dato del campo
    filterFieldSelected: function(field) {
      this.isBoolean = false;
      this.headersFilter.forEach(hf => {
        if (hf.value === field) {
          switch (hf.type) {
            case Date:
              this.currentTypeFilters = "Date";
              this.currentTypeFiltersList = ["From", "To", "Equal"];
              break;
            case Number:
              this.currentTypeFilters = "Number";
              this.currentTypeFiltersList = ["Bigger", "Smaller", "Equal"];
              break;
            case Boolean:
              this.isBoolean = true;
              this.filter = "Equal";
              this.currentFilter = hf.text;
              this.currentTypeFilters = "Boolean";
              this.currentTypeFiltersList = ["Equal"];
              break;
            default:
              this.currentTypeFilters = "Text";
              this.currentTypeFiltersList = ["StartWith", "Contains"];
              break;
          }
        }
      });
    },
    //
    isHiddenColumn(key) {
      let classColumn = "text-xs-left ";
      if (this.hideColumns) {
        this.hideColumns.forEach(col => {
          if (col === key) {
            classColumn += "hide-column text-xs-left";
          }
        });
      }
      if (key === "RowNum") {
        classColumn += "hide-column text-xs-left";
      }
      return classColumn;
    },

    coloratedCell(row, col) {
      if (this.colorRow) {
        // Ho usato tutti valori statici perché le regole erano tutte diverse
        if (row.weightDif > 0 && col == "weightDif") return "colorated";

        if (row.volDif > 0 && row.volBol > 0 && col == "volDif")
          return "colorated";

        if (row.volPesDif > 0 && row.volBol > 0 && col == "volPesDif")
          return "colorated";

        if (row.resultDif > 0 && col == "resultDif") return "colorated";
      } else return;
    },

    download(type) {
      this.$emit("download", type);
    },

    create() {
      router.push({ name: this.createComponentRoute });
    }

    // isHiddenColumn: function (key) {
    //   this.hideColumns.forEach(col => {
    //     if (col === key) {
    //       return 'hide-column text-xs-left';
    //     } else {
    //       return 'text-xs-left';
    //     }
    //   });
    // }
  },
  computed: {
    // validazione campo filter
    filterErrors() {
      const errors = [];
      if (!this.$v.filter.$dirty) return errors;
      !this.$v.filter.required && errors.push(requiredMsg);
      return errors;
    },
    // validazione campo column
    columnErrors() {
      const errors = [];
      if (!this.$v.column.$dirty) return errors;
      !this.$v.column.required && errors.push(requiredMsg);
      return errors;
    },
    // validazione campo value
    valueErrors() {
      const errors = [];
      if (!this.$v.value.$dirty) return errors;
      !this.$v.value.required && errors.push(requiredMsg);
      return errors;
    }
  }
};
</script>
<style>
.style-chip {
  border-radius: 0px !important;
}

.color-filter-bar {
  background-color: #5d6367;
}

.button-add-filters {
  color: white !important;
  background-color: black !important;
  border-radius: 0px;
}

.button-can-create {
  border-radius: 0px;
  color: black !important;
  background-color: white !important;
  margin-right: 10px;
}

.v-table__overflow {
  width: 100% !important;
  height: 64vh;
  overflow-y: auto !important;
}
.fixed-header {
  display: flex;
  flex-direction: column;
  height: 100%;
}

th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}

th:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}

tr.v-datatable__progress th {
  height: 1px;
}

.v-table__overflow {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-x: auto;
  overflow-y: auto;
}

.v-datatable.v-table {
  flex-grow: 0;
  flex-shrink: 1;
}

.v-datatable__actions {
  flex-wrap: nowrap;
}

.v-datatable__actions__pagination {
  white-space: nowrap;
}
.hide-column {
  display: none;
}
.text-start {
  white-space: nowrap; /*keep text on one line */
  overflow: hidden; /*prevent text from being shown outside the border */
  text-overflow: ellipsis; /*cut off text with an ellipsis*/
  /* width: 250px; */
  height: auto;
}
.v-data-table__mobile-row {
  width: 90vw;
}
@media screen and (max-width: 600px) {
  th {
    width: 90vw;
  }
}

.colorated {
  color: red;
}
.v-data-table__wrapper {
  height: 79vh;
  overflow-x: auto !important;
  overflow-y: auto !important;
}

.d-sm-table-cell {
  padding-left: 13px !important;
}
.text-start, .text-start .sortable {
  padding-left: 13px !important;
}
</style>
